export const viewupZIndex = {
  fixed: {
    1000: 1000,
    1001: 1001,
    1002: 1002,
    1003: 1003,
    1004: 1004,
    1005: 1005,
    1006: 1006,
    1007: 1007,
    1008: 1008,
    1009: 1009,
  },
  global: {
    9990: 9990,
    9991: 9991,
    9992: 9992,
    9993: 9993,
    9994: 9994,
    9995: 9995,
    9996: 9996,
    9997: 9997,
    9998: 9998,
    9999: 9999,
  },
  modal: {
    1090: 1090,
    1091: 1091,
    1092: 1092,
    1093: 1093,
    1094: 1094,
    1095: 1095,
    1096: 1096,
    1097: 1097,
    1098: 1098,
    1099: 1099,
  },
  popover: {
    1050: 1050,
    1051: 1051,
    1052: 1052,
    1053: 1053,
    1054: 1054,
    1055: 1055,
    1056: 1056,
    1057: 1057,
    1058: 1058,
    1059: 1059,
  },
  tooltip: {
    800: 800,
    801: 801,
    802: 802,
    803: 803,
    804: 804,
    805: 805,
    806: 806,
    807: 807,
    808: 808,
    809: 809,
  },
};

export type ViewupZIndex = typeof viewupZIndex;
